import { PUBLICATION_IMAGE_PREFIX } from "./publicationImage";

/**
 * Image sources we will render from server-supplied content (notification
 * avatars, publication hero images, images inside a post): `https://…` or
 * root-relative `/…`, nothing else. The same rule the API enforces on a
 * publication's hero image — repeated here because a binary in the wild may
 * outlive any one server-side check. Images uploaded in the publication editor
 * are served by the configured API, which is plain http on a dev machine.
 */
export const isSafeImageSrc = (src: string | null | undefined): src is string =>
  typeof src === "string" &&
  (src.startsWith("https://") || /^\/(?![/\\])/.test(src) || src.startsWith(PUBLICATION_IMAGE_PREFIX));
